/**
 * The Monitor page's data: the inbox, the watchlists and the standing sources, read and handed to
 * the presentational `MonitorWorkspace` (`useMonitorPanes`). Opening the page marks the reader's
 * visit, so their bell drops to zero.
 */
import { useState } from 'react'
import {
  type MonitorTab,
  MonitorWorkspace,
} from '@/components/program-view/workspaces/MonitorWorkspace'
import { useInboxPane, useRulesPane, useSourcesPane } from './useMonitorPanes'

export function CaseMonitor({ caseId }: { caseId: string }) {
  const [tab, setTab] = useState<MonitorTab>('inbox')
  const inbox = useInboxPane(caseId)
  const rules = useRulesPane(caseId)
  const sources = useSourcesPane(caseId)
  return (
    <MonitorWorkspace
      tab={{ value: tab, onChange: setTab }}
      inbox={inbox}
      rules={rules}
      sources={sources}
    />
  )
}
